import BaseStore from './base-store'
import StoreProxy from './store_proxy'
import {API2_PULSE} from 'consts/api2'

const LIMIT = 20

export class TrackerItem extends BaseStore {
  constructor(values = {}) {
    super({
      id: undefined,
      name: undefined,
      type: undefined,
      signals: undefined,
      people: undefined,
      logo_url: undefined,
      shared_company_id: undefined,
      ...values
    })
  }

  get user_entity_id(){
    return this._state.id
  }
}

export class Tracker extends BaseStore {
  constructor() {
    super({
      items: [],
      total: 0,
      tracker_types_count: {},
      cache: new Map()
    })
  }

  async doLoad(rest, params = {}) {
    if (params.more) {
      const result = await (rest || this._rest).get(`${API2_PULSE}/trackers`, {before: this._state.items.at(-1).id, limit: LIMIT, ...params})
      this._state.items.push(...result.items.map(data => new TrackerItem(data)))
    }
    else {
      const result = await (rest || this._rest).get(`${API2_PULSE}/trackers`, {limit: LIMIT, ...params})
      const existing_ids = new Set(this._state.items.map(i => i.id))
      this._state.items = result.items.map(
        data => existing_ids.has(data.id) 
          ? this._updateItem(this.getItem(data.id), data) 
          : this._updateItem(this._getFromCache(data.id) || new TrackerItem(data), data)
      )
      this._state.total = result.total
      this._state.tracker_types_count = result.tracker_types_count
    }
  }

  _updateItem(item, next) {
    if (!item) return
    for (const key in next) {
      if (key === 'logo_url' && item[key]) {
        const [new_val] = next[key].split('?')
        const [prev_val] = item[key].split('?')
        if (new_val === prev_val) continue
      }
      item[key] = next[key]
    }
    return item
  }

  getItem(id) {
    return this._getFromCache(id) || this._state.items.find(x => x.id === id)
  }

  _getFromCache(id){
    return this._state.cache.get(id)
  }

  getByShCompany(id) {
    return this._state.items.find(x => x.shared_company_id === id)
  }

  removeItem(id) {
    // TODO
    // const item = this.getItem(id)
    // if (item) {
    //   this._state.items = this._state.items.filter(x => x.id !== id)
    //   this._state.tracker_types_count[item.type] -= 1
    //   this._state.tracker_types_count.all -= 1
    //   this._state.total -= 1
    // }
  }

  clear(){
    this._state.items.length = 0
    this._state.type_counts = {}
    this._state.total = 0
  }

  abort(){
    this._rest.abortAll()
  }

  clearCache(){
    this._state.cache.clear()
  }
  
  pinItem(id){
    if (this._state.cache.has(id)) {
      return this._getFromCache(id)
    }

    const item = this.getItem(id)

    if (item !== undefined) {
      this._state.cache.set(id, item)
    }
  }

  pinManually(data){
    const item = this.getItem(data.id)
    if (item) {
      this._updateItem(item, data)
    }
    else {
      this._state.cache.set(data.id, new TrackerItem(data))
    }
  }
}

const $tracker = new StoreProxy(new Tracker())
export default $tracker
